import { gql } from '@apollo/client';
import Fragments from './fragments';

export const DOCUMENT_CLAUSE_QUERY = gql`
  query documentClause($clauseId: Int!) {
    documentClause(clauseId: $clauseId) {
      ...documentClauseItem
    }
  }
  ${Fragments.documentClauseItem}
`;

export const CLAUSE_TYPES_QUERY = gql`
  query clauseTypes {
    clauseTypes {
      id
      code
      name
    }
  }
`;

export const PARENT_CLAUSES_QUERY = gql`
  query parentClauses {
    parentClauses {
      id
      name
    }
  }
`;
